import { ASSETS_IMAGE_BASE } from '@/utils/constants/common';

const images = import.meta.glob<string>('@/assets/images/**/*', { eager: true, as: 'url' });

export const getAssetImageUrl = (path: string): string | undefined => {
  return images[`${ASSETS_IMAGE_BASE}${path}`];
};
